<template>
  <div class="hello">
    <ul>
      <span
        @click="toggle(item)"
        class="gradefilter"
        :class="{selected: isSelected(item)}"
        v-for="item in allGrades"
        v-bind:key="item"
      >{{item}}</span>

      <div v-for="item in allCamps" v-bind:key="item['.uid']">
        <session-list :campName="item.organizationName" :allSessions="item.sessions" />
      </div>
    </ul>
  </div>
</template>

<script>
import SessionList from "./SessionList";
export default {
  fiery: true, // required to add this.$fiery to this component
  name: "CampList",
  components: { SessionList },
  props: {
    week:Date
  },
  data() {
    return {
      update: 0,
      allGrades: ["PreK", "1", "2", "3", "4", "5", "6", "7", "8"],
      selectedGrades: ["PreK", "1", "2", "3", "4", "5", "6", "7", "8"]
    };
  },
  methods: {
    sessionMatchesGrades(session, selectedGrades) {
      let intersection = session.grades.filter(x => selectedGrades.includes(x));
      return intersection.length;
    },
    isSelected(grade) {
      return this.selectedGrades.indexOf(grade) != -1;
    },
    toggle(grade) {
      if (this.isSelected(grade))
        this.selectedGrades = this.selectedGrades.filter(thisgrade => {
          return thisgrade != grade;
        });
      else this.selectedGrades.push(grade);
      // this.selectedGrades = [grade];
    }
  },

  computed: {
    allCamps() {
      console.log("recomputingallcamps" + this.update);
      const allcamps = {};
      this.allSessions.forEach(session => {
        if (allcamps[session.organization_id] == undefined) {
          allcamps[session.organization_id] = {
            organizationName: session.organization_id,
            sessions: []
          };
        }
        if (this.sessionMatchesGrades(session, this.selectedGrades)) {
          allcamps[session.organization_id]["sessions"].push(session);
        }
      });
      return allcamps;
    },
    allSessions() {
      console.log("recomputing sessions" + this.week); // eslint-disable-line no-console
      //   let limit = 10;
      const vm = this;
      let options = {
        // query: episodes =>
        //   episodes
        //     // .where('created_by', '==', currentUserId)
        //     // .where('status', '==', status)
        //     .limit(limit),
        onSuccess: () => {
          vm.update++;
          vm.$forceUpdate();
        },
        onError: error => {
          console.log("error: " + error);
        }
      };
      let start = new Date("June 8, 2020");
      let end = new Date("June 8, 2020");
      try {
        start = new Date(this.week);
        end = new Date(this.week);
      } catch (error) {
        console.log("Error");
      }
      if (!isValidDate(start)) {
        start = new Date("June 8, 2020");
        end = new Date("June 8, 2020");
      }

      start.setDate(start.getDate() - 1);
      end.setDate(end.getDate() + 1);

      return this.$fiery(
        //   let museums = db.collectionGroup('landmarks').where('type', '==', 'museum');

        this.$fs
          .collectionGroup("sessions") //.orderBy("created", "desc")
          // this.$fs
          //   .collection("Organizations")
          //   .doc("Trackers")
          //   .collection("sessions")
          //   .where("start_date", ">=", start)
          .where("start_date", ">=", start)
          .where("start_date", "<=", end),
        //   .where("start_date", "==", start.setDate(start.getDate() - 1))
        //   .where("start_date", "<=", start.setDate(start.getDate() + 2)),
        options,
        "sessions"
      );
    }
  }
};

function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div {
  background-color: rgb(219, 216, 212);
}
h3 {
  margin: 40px 0 0;
}
ul {
  margin:0px;
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.gradefilter {
  background: rgb(247, 209, 209);
  border: 1px solid gray;
  border-radius: 1em;
  margin-left: 1em;
  padding: 0 1em 0 1em;
}
.gradefilter.selected {
  background: rgb(245, 143, 143);
}
</style>
